/* eslint-disable quotes */
/* eslint-disable max-lines, no-template-curly-in-string */
import { flattenMessages } from './util';

const messages = {
  appTitle: 'ZeroTime™',
  zeroTime: 'ZeroTime™',
  zeroTimeLogo: 'ZeroTime™ logo',
  login: 'Login',
  signin: 'Sign-In',
  pinnedMsg: 'Pin side panel',
  tsErrorPage: {
    rebrandingTitle: 'No timesheet found',
    title: 'Timesheet not available',
    rebrandingSubtext:
      'We couldn’t retrieve this timesheet, please contact with your administrator.',
    subtext: 'Please contact your Replicon system administrator.'
  },
  loginPage: {
    LoginMessage: 'Freedom! No More Manual Time Tracking.',
    LoginMessage1: 'Let ZeroTime Do It for You.',
    bodyMessage: 'Need Assistance? Call us toll free!',
    northAmerica: 'North America',
    OtherCountries: 'Other Countries',
    emailUsAT: 'Email us at',
    northPhone: '1-877-862-2519',
    otherPhone: '+800-8622-5192',
    email: 'support@replicon.com',
    direct: 'Direct',
    directNo: '+1 650-286-9200',
    australia: 'Australia',
    australiaNo: '1800-223-198',
    uk: 'United Kingdom',
    ukNo: '+44 (0) 80 0368 5475',
    footerMessage1: 'Trusted by 3000+ Global Businesses',
    footerMessage2: 'Get 100% Accurate Time and Work Data',
    footerMessage3: 'Gain up to 10-15% Increase in Employee Productivity'
  },
  offlineScreen: {
    online: {
      message: 'You are back online'
    },
    offline: {
      message: 'You appear to be offline!',
      description:
        'ZT is unable to connect to the internet. Please check your internet connection and try again.',
      tryAgain: 'TRY AGAIN'
    }
  },
  appMenu: {
    myReplicon: 'My Replicon',
    replicon: 'Replicon',
    polaris: 'Polaris',
    about: 'About',
    logout: 'Logout',
    totalTimeFromDurationLabels: '{hours} Hrs',
    feedback: 'Feedback',
    desktopApp: 'Desktop App',
    downloadDesktopApp: 'Desktop App {variant}',
    macOs: 'Mac OS X',
    windowsOs: 'Windows',
    requires: 'Requires {version} or later',
    downloadDescription:
      'Manage your day In real-time with our ZT desktop app!',
    downloadDescriptionFirstLine: 'Manage your day In real-time',
    downloadDescriptionSecondLine: 'with our ZT desktop app!',
    desktopAppDescription: 'Desktop App for MAC and WINDOWS',
    getDesktopAppDescription: 'Get your desktop application here.',
    settings: 'Settings'
  },
  settingsDialog: {
    settings: 'Settings',
    save: 'Save',
    cancel: 'Cancel',
    autoPopulate: 'Auto Populate',
    description: 'Automatically Populate your timesheets.',
    success: {
      startEndSettings: 'Successfully saved Start/End Settings',
      smartSuggestionSettings: 'Successfully saved Smart Suggestion Settings',
      autoPilotSettings: 'Successfully saved Auto Populate Settings'
    },
    error: {
      startEndSettings: 'Failed to save the Start/End Settings',
      smartSuggestionSettings: 'Failed to save the Smart Suggestion Settings',
      autoPilotSettings: 'Failed to save the Auto Populate Settings'
    },
    status: 'Auto populate status',
    startEndState: 'Start and end time state',
    smartSuggestionState: 'Smart suggestion state'
  },
  aboutDialog: {
    about: 'About',
    close: 'Close',
    applicationName: 'Application Name',
    timeIntelligence: 'ZeroTime™',
    version: 'Version',
    licenseInformation: 'License Information',
    privacyPolicy: 'Privacy Policy',
    termsAndConditions: 'Terms and Conditions',
    copyrightInformation: 'Copyright Information',
    copyright: 'Replicon Inc, © 1996 - {copyrightYear}'
  },
  feedbackDialog: {
    feedback: 'Send Feedback',
    question: "What's the lowdown?",
    yourFeedback: 'Your Feedback',
    includeDiagnostics: 'Include diagnostic information*',
    diagnostics:
      '* By including diagnostic information some personal application usage data will be sent to Replicon for the exclusive purpose of reproducing and/or gaining further insight into any issue you are encountering. It will not be shared with any 3rd party or used for any other purpose.',
    send: 'Send',
    cancel: 'Cancel',
    success: 'Feedback sent! Thank you!',
    error: 'Failed to send Feedback!'
  },
  crashPage: {
    imageAlt: 'Application Crash',
    banner: 'Oops, something went wrong',
    message: 'This issue has been automatically reported',
    restartSession: 'Restart Session'
  },
  substituteUserBanner: {
    loggedInAs: 'You are using Replicon on behalf of',
    returnButton: 'RETURN TO MENU'
  },
  abbreviatedNumberSuffix: {
    thousand: 'K',
    million: 'M',
    billion: 'B',
    trillion: 'T'
  },
  dayOfWeek: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  calendar: {
    day: 'Day',
    month: 'Month',
    week: 'Week',
    year: 'Year',
    periodDropdown: 'Period Dropdown',
    acceptedDuration: 'Accepted: {duration}',
    more: '{count} more',
    na: 'N/A',
    edit: 'Edit',
    disallowedMovingEvents: 'Moving events between the days not allowed',
    goToToday: 'Today',
    currentWeek: 'Current Week',
    selectAll: 'Select All',
    deselectAll: 'Deselect All'
  },
  notSupportedPage: {
    description: 'Sorry for the inconvenience.',
    title: 'Unfortunately this view does not support small screens'
  },
  notFoundPage: {
    description:
      'The link you followed is probably broken, or the page has been removed.',
    pageNotFound: '404 Page Not Found',
    title: 'Sorry, page not found.',
    backtoHome: 'Back to Home',
    errorIcon403: 'Error 403 icon',
    errorIcon404: 'Error 404 icon',
    errorIcon500: 'Error 500 icon',
    errorIcon503: 'Error 503 icon'
  },
  unhandledErrorPage: {
    description: 'To report the issue, contact {email}',
    eventId: 'Error trace ID: {eventId}',
    title: 'Unknown Error',
    backtoHome: 'Back to Home'
  },
  forbiddenPage: {
    greeting: 'Hello,',
    description1: 'You currently ',
    // eslint-disable-next-line
    description2: "don't have permission ",
    description3:
      'to use this app, please contact your system administrator if you think this is a mistake.'
  },
  unavailablePage: {
    description:
      'The application is currently under maintenance. Please try again soon. Sorry for the inconvenience.',
    title: 'Maintenance'
  },
  tabs: {
    myWork: 'My Work',
    smartDiary: 'Smart Diary',
    smartTimesheet: 'Smart Timesheet',
    collectors: 'Collectors',
    settings: 'Settings',
    insights: 'Insights'
  },
  collectorTabs: {
    companyCollectors: 'COMPANY COLLECTORS',
    userCollectors: 'USER COLLECTORS',
    installedCollectors: 'INSTALLED COLLECTORS',
    allCollectors: 'HOME',
    installed: 'Installed'
  },
  timelineView: {
    prev: 'Previous Period',
    next: 'Next Period',
    dateRange: 'Current date selected',
    closeHeader: 'Close Bulk Action Header'
  },
  collectors: {
    categoryText: 'Category: {category}',
    publishedBy: 'By {by}',
    imageAltText: 'collector {collectorName}',
    clearSearch: 'Clear Search',
    uninstallSuccessTitle: 'Collector Uninstall Success',
    uninstallSuccessMessage1: 'Uninstallation completed',
    uninstallSuccessMessage2: '{collector} collector successfully uninstalled.',
    uninstallSuccessMessage3: 'You may close this window.',
    configure: 'Configure',
    install: 'INSTALL',
    settings: 'SETTINGS',
    details: 'DETAILS',
    backIconMsg: 'Back to collectors home page',
    syncMessages: {
      f8dc429148bc4abe9854ec5c3a7355db:
        'Thanks for installing the Asana collector for ZeroTime™. We are connecting ZeroTime™ to your Asana projects.'
    },
    uninstallSuccessPage: {
      _9a4a7283fdf645e5ad9ecb8503c48fe3: {
        uninstallSuccessMessage3:
          'Forwarding you to Microsoft admin center to remove the ZeroTime Add-in.'
      },
      _9a15fb9428ed4c079fde7468b29461fa: {
        uninstallSuccessMessage3:
          'Forwarding you to Microsoft admin center to remove the ZeroTime Add-in.'
      }
    },

    connected: 'Connected',
    installTitle: 'Collector Install',
    successTitle: 'Collector Install Success',
    installMessage1: 'Forwarding to {collector}',
    installMessage2: 'Forwarding to {collector} collector for installation.',
    installMessage3: 'Get Ready to Connect.',
    installSuccessMessage1: 'Installation completed',
    installSuccessMessage2: '{collector} collector successfully installed.',
    installSuccessMessage3: 'You may close this window.',
    installFailMessage1: 'Installation failed',
    installFailMessage2: '{collector} collector installed partially.',
    installFailMessage3: 'Please contact support team for the fix.',
    installFailReason: 'Insufficient scope access.',
    uninstallTitle: 'Collector Uninstall',
    uninstallMessage1: 'We are sorry to see you leave :(',
    uninstallMessage2:
      'Forwarding to {collector} collector for uninstallation.',
    uninstallMessage3: 'Please do not close this window.',
    successClose: 'Close',
    asCompanyLevel: 'As Company Level',
    by: 'By',
    category: 'Category:',
    collectorErrorTitle: 'Collector Error',
    collectorAccessDeniedTitle: 'Collector Access Denied',
    collectorInsufficientPermissionsTitle: 'Collector Access Denied',
    search: 'Search',
    all: 'All',
    installed: 'Installed',
    notInstalled: 'Not Installed',
    availability: 'Availability:',
    uninstall: 'Uninstall',
    overview: 'OVERVIEW',
    manage: 'MANAGE',
    modify: 'MODIFY',
    appScope: {
      TENANT: 'Company (Admin Only)',
      USER: 'Self'
    },
    installCopy: 'Install a copy',
    disconnecting: 'Disconnecting'
  },
  collectorSetting: {
    title: '{prefix} Collector Settings',
    companyCollectorTitle: 'Settings',
    screentimeSettings: 'Screentime Settings',
    appTrackingSettings: 'App Tracking Settings',
    appTracking: 'App Tracking',
    uninstall: 'UNINSTALL',
    cancel: 'CANCEL',
    disconnect: 'DISCONNECT',
    disconnectSmall: 'Disconnect',
    save: 'SAVE',
    collectorTitle: 'Company {prefix} collector',
    userEnableLabel: 'Allow users to opt-out',
    collectorEnable: 'Enabled',
    collectorDisable: 'Disabled',
    userEnabled: 'Yes',
    disconnectSuccessMessage:
      'Disconnected successfully. It will take up to an hour to stop receiving events.',
    userDisabled: 'No',
    downLoad: 'Download',
    errors: '{number} Error(s)',
    screentimeError: {
      invalidInput: 'Please enable one of setting above before you saving.'
    },
    isInvalidRow:
      'Please select an option from the groups, after you created a new row.',
    details: {
      errorBanner: {
        f8dc429148bc4abe9854ec5c3a7355db:
          'ZeroTime™ unable to connect to some of your Asana Projects ',
        general:
          'There are some issues with this collector. Please find more information below'
      },
      iconErrorTooltip: 'Collector install has errors',
      dialogTitle: 'Details',
      syncingProjectsMessage: 'Syncing Projects ...',
      retry: 'RETRY'
    },
    install: 'Install',
    collectorState: 'Collector State',
    optedIn: 'Opted-In',
    yes: 'Yes',
    no: 'No',
    disconnectingMessage1:
      'This action will disconnect ZeroTime from all your installed devices.',
    disconnectingMessage2: 'Are you sure you want to continue?',
    collectorSaveSuccessMessage: 'Successfully saved Collectors Settings'
  },
  collectorError: {
    timeIntelligence: 'ZeroTime™',
    errorMessage1: 'Oops, something went wrong!',
    errorInstallMessage: 'Install Failed',
    errorUninstallMessage: 'Uninstall Failed',
    errorUnauthorizedMessage: 'Unauthorized',
    installMessage: 'collector installation has failed.',
    uninstallMessage: 'collector uninstallation has failed.',
    unauthorizedMessage: 'collector authentication has failed.',
    closeWindowMessage: 'Please close this window and try again.',
    configureDisabledMessage:
      'Option currently disabled due to error(s). Please click on Manage for more information.',
    errorNotification:
      "There is a problem with some of your collector services. Please visit collector's details ",
    collector: 'Collector',
    traceId: 'Trace ID:',
    accessDeniedMessage1: 'Cancelled',
    accessDeniedMessage2: 'Please retry. You may close this window now.',
    insufficientPermissions: 'Access Denied',
    insufficientPermissionsDescription:
      'Your credentials do not allow you to install this collector.  Please validate your permissions and product licenses for the application and try again.',
    noMatchingCollector: 'No matching collectors found',
    errorLogoMessage: 'Computer broken'
  },
  notes: {
    all: 'All',
    note: 'Note',
    inbox: 'Inbox',
    private: 'Private',
    accepted: 'Accepted',
    trash: 'Trash',
    unclassified: 'Inbox',
    multiple: 'Multiple',
    excluded: 'Excluded'
  },
  noteSelector: {
    noneSelected: 'No Note Selected',
    singularSelected: 'Note Selected',
    pluralSelected: 'Notes Selected',
    partialSelected: '{selectedCount} of {totalCount} Selected',
    oneSelected: '1 Note Selected',
    notesSelected: '{totalCount} Notes Selected',
    selectAllNotes: 'Select all notes having total duration {duration}',
    selectAllNotedDay:
      'Select all notes of "{day}" having "{duration}" total duration',
    selectNote: 'Select Note'
  },
  notesGroupBySelector: {
    none: 'None',
    labels: 'Labels',
    title: 'Group By'
  },
  note: {
    classification: 'Classification: {value}',
    split: {
      maxReached:
        "You've reached maximum (5) available split options for this entry.",
      removeTitle: 'Removing the Entry',
      removeMessage1:
        "You're about to remove an entry. This action is irreversible",
      removeMessage2: 'Are you sure you want to remove?',
      remove: 'Remove',
      cancel: 'Cancel',
      split: 'Split',
      add: 'Add',
      cancelTitle: 'Cancelling split note',
      cancelMessage1: "You're about to cancel the split note. ",
      cancelMessage2: 'Are you sure you want to cancel split note?',
      cancelYes: 'Yes, Cancel',
      cancelNo: 'No, go back',
      enterMsg: 'Interact with {entryName}',
      splitEntry: 'Split this entry',
      removeEntry: 'Remove this entry',
      addBack: 'Add this entry back'
    },
    groupBy: {
      uncategorizedGroupTitle: 'Multiple events',
      uncategorizedCountTitle: 'Uncategorized events ({count})',
      selectAllHeader: 'Select all notes of this Uncategorized event'
    },
    multiEdit: {
      cancelTitle: 'Cancelling Edit',
      cancelMessage1: "You're about to cancel editing the notes. ",
      cancelMessage2: 'Are you sure you want to cancel editing?',
      cancelYes: 'Yes, Cancel',
      cancelNo: 'No, go back',
      title: 'Editing',
      notesUpdated: 'Notes updated',
      nNotesUpdated: '{count} notes updated'
    },
    merge: {
      title: "You're about to merge {count} entries...",
      moreDetails: 'More details',
      lessDetails: 'Less details',
      cancelTitle: 'Cancelling Merge',
      cancelMessage1: "You're about to cancel merging the notes. ",
      cancelMessage2: 'Are you sure you want to cancel merge?',
      success: 'Notes merged',
      failure: 'Notes merge failed',
      mergedTo: {
        common: '{count} notes merged to "{message}"',
        unclassified: '{count} notes merged to "{message}" and moved to Inbox',
        accepted: '{count} notes merged to "{message}" and moved to Accepted',
        private: '{count} notes merged to "{message}" and moved to Private'
      },
      mergeTo: 'Merge To...',
      toThis: 'To this...'
    },
    groupEdit: {
      title: 'Editing Group Events',
      moreDetails: 'More details',
      lessDetails: 'Less details',
      cancelTitle: 'Cancelling Group Edit',
      cancelMessage1: "You're about to cancel editing the group. ",
      cancelMessage2: 'Are you sure you want to cancel the group edit?',
      success: 'Group edit successful',
      failure: 'Group edit failed',
      groupEditTo: 'Save To...',
      editTitle: 'Group Details'
    },
    addNoteDialog: {
      denySuggestions: 'Deny all "{value}" suggestions'
    },
    clearDescription: 'Clear notes description',
    clearComment: 'Clear notes comment',
    splitEntryTitle: 'Entry',
    splitNote: 'Split To...',
    saveNote: 'Save To...',
    current: 'Current',
    emptyNote: 'No note added',
    addNoteTitle: 'Add a Note',
    addNote: 'Add Note',
    splitNoteTitle: 'Splitting Entry',
    editNoteTitle: 'Editing Note',
    editNote: 'Update',
    moreDetails: 'More details',
    lessDetails: 'Less details',
    lastEdit: 'Last Edit: {datetime}',
    createdAt: 'Created At: {datetime}',
    cancel: 'Cancel',
    addNotePlaceholder: 'Add your note here',
    selectDate: 'Select Date',
    play: 'Play',
    pause: 'Pause',
    reset: 'Reset',
    timeDuration: 'Time Duration',
    startTime: 'Start Time',
    endTime: 'End Time',
    duration: 'Duration',
    durationWithHours: '{duration} Hrs',
    durationWithoutHours: '{duration}',
    ok: 'Ok',
    more: 'More',
    less: 'Less',
    hoursSuffix: 'Hrs',
    error: {
      invalidDuration: 'Invalid Duration',
      startTimeRequired: 'Start Time is required',
      endTimeRequired: 'End Time is required',
      endTimeShouldBeGreaterThanStartTime: 'Invalid End time',
      startAndEndTimeShouldNotBeEqual: 'Start and End time cannot be the same',
      durationRequired: 'Duration is required',
      time: 'Please Select Correct Time',
      invalidTimeFormat: 'Invalid Time Format',
      maxCommentLength: 'Max Character',
      fieldRequired: 'Field Required',
      emptyNote: 'The note must not be empty',
      maxDurationExceeded:
        'Invalid Duration. Please update to be within 24 hours.',
      durationShouldBeInStartTimeEndTimeRange: 'Invalid Duration'
    },
    stopTimerDialog: {
      title: 'Timer is still running',
      addMessage: 'Adding this note will stop the timer.',
      updateMessage: 'Updating this note will stop the timer.',
      message2: 'Would you like to stop the timer?',
      yes: 'Yes, Stop',
      cancel: 'No, Cancel'
    },
    cancelDialog: {
      title: 'There is unsaved data in the note.',
      message1: 'Canceling this note will discard the changes.',
      message2: 'Would you like to cancel?',
      no: 'No',
      yes: 'Yes, Cancel',
      cancelYes: 'Yes, Cancel',
      cancelNo: 'No, go back'
    },
    resetStopTimerDialog: {
      title: 'Timer is still running',
      message1: 'Changing the date will reset the timer.',
      message2: 'Would you like to reset the timer?',
      yes: 'Yes, Reset',
      cancel: 'No, Cancel'
    },
    inlineTimer: {
      title: 'Timer is still running',
      timerRunningMessage: 'Please select an action for your timer.',
      acceptedMessage: 'Accepting the signal will stop the timer.',
      cancel: 'Cancel',
      stopTimer: 'Stop Timer',
      keepTimerRunning: 'Keep Timer Running',
      continue: 'Continue',
      stopBackgroundTimer: 'Active timer running, Please stop it',
      backgroundTimerMessage: 'Timer Running for: ',
      logoutBanner: {
        title: 'Active Timer Running',
        content:
          'An active timer is running for a note, please stop the timer to logout',
        actionButton: {
          secondary: 'No, Cancel',
          primary: 'Yes, Stop And Logout'
        }
      }
    },
    empty: {
      all: {
        rebrandingTitle: 'Hello there!',
        rebrandingSubtitle:
          'Nothing here yet. Please contact your admin for support on ZeroTime™ collectors.'
      },
      unclassified: {
        rebrandingTitle: 'Well done!',
        rebrandingSubtitle: 'You did it!  No action required at this time.'
      },
      private: {
        rebrandingTitle: 'I feel empty here',
        rebrandingSubtitle:
          'Looks like you don’t have anything marked as private.'
      },
      accepted: {
        rebrandingTitle: 'Action required',
        rebrandingSubtitle:
          'Nothing left to add to your Timesheet! Please accept entries in your Inbox to be added to your Timesheet.'
      },
      trash: {
        rebrandingTitle: 'Your trash is empty!',
        rebrandingSubtitle: 'You did!',
        banner: 'Entries in trash will be automatically deleted after 30 days.',
        deleteAll: 'Empty trash',
        deleteDialogTitle: 'Confirm deleting all entries',
        messageTitle:
          'This action will permanently delete all your entries in trash.',
        messageSubtitle: 'Are you sure you want to continue?',
        cancelButton: 'NO, Cancel',
        confirmationButton: 'Yes, Delete'
      },
      noMatchingNotes: 'No matching notes found'
    },
    attributes: {
      notFound: 'No further details available',
      more: {
        //zoom
        topic: 'Meeting Topic',
        'participant.user_name': 'User',
        'participant.email': 'Email',
        //google
        htmlLink: 'Link',
        //desktop
        username: 'User',
        //google chat
        //outlook
        //slack
        //team-chat
        //teams
        joinWebUrl: 'Link'
      }
    },
    classificationAccept: 'Accept',
    copyComment: 'COPY FROM NOTE ABOVE',
    undoComment: 'UNDO',
    yourNote: 'Your note',
    startDate: 'Start Date',
    timesheetComment: 'Timesheet Comment',
    total: 'Total',
    uncategorized: 'Uncategorized'
  },
  timesheetPeriods: {
    custom: 'Custom',
    today: 'Today',
    currentPeriod: 'Current Period',
    lastPeriod: 'Last Period',
    label: 'View:',
    prev: 'Previous Timesheet Periods',
    next: 'Next Timesheet Periods'
  },
  timeSignalActions: {
    inbox: 'Inbox',
    private: 'Private',
    accept: 'Accept',
    trash: 'Trash',
    timer: 'Timer',

    deleteForever: 'Delete Forever',
    accepted: 'Accepted',
    splitNote: 'Split Note',
    edit: 'Edit',
    groupEdit: 'Group Edit',
    merge: 'Merge Notes',
    diaryIncludeNote: 'Include In Smart Diary',
    diaryExcludeNote: 'Exclude From Smart Diary'
  },
  excluded: {
    tooltip: 'This is excluded from your Timesheet'
  },
  customLabels: {
    addCustomLabel: 'Add custom label',
    loading: 'Loading...',
    addKey: 'Add Key',
    editKey: 'Edit Key',
    updateButton: 'Update',
    cancel: 'Cancel',
    add: 'Add',
    update: 'Update',
    key: 'Key',
    keyPickerPlaceholder: 'Enter a Key',
    valuePickerPlaceholder: 'Enter a Value',
    customLabel: 'Add Custom Labels',
    addCustomLabelKey: 'Add "{option}" as New Key',
    label: 'Label',
    value: 'Value',
    addValueKey: 'Add "{option}" as New Value',
    typeToAddValue: 'Type to Add Value',
    typeToAddKey: 'Type to Add Key',
    duplicateKeyError: 'Key Already Exist',
    duplicateValueError: 'Value Already Exist',
    deleteConfirmationTitle: 'Deleting Key',
    deleteConfirmationMsg1: 'Deleting this key will also delete its values.',
    deleteConfirmationMsg2: 'Are you sure you want to delete this key?',
    deleteConfirmationCancel: 'Cancel',
    deleteConfirmationDelete: 'Delete',
    deleteValueConfirmationTitle: 'Deleting Value',
    deleteValueConfirmationMsg: 'Are you sure you want to delete this value?',
    editValue: 'Edit Value'
  },
  timesheetLabels: {
    title: 'Timesheet Labels',
    noResults: 'No results found.',
    comment: 'Comment',
    notSelected: 'Not Selected',
    noValueLabel: 'no value selected {label}',
    suggestedValue: 'suggested {label}: {value}',
    selectedValue: 'selected {label}: {value}',
    noneOptions: {
      client: 'No Client',
      project: 'No Project',
      task: 'No Task'
    },
    commentsPlaceholder: 'Timesheet Comment',
    emptyTaskToolTip: 'Please select a project first',
    acceptAllSuggestions: 'Confirm All Smart Suggestions',
    denyAllSuggestions: 'Deny All Suggestions',
    timesheetComment: 'Timesheet Comment',
    timesheetCommentPlaceholder: 'Add your timesheet comment here',
    editTimesheetLable: 'Edit timesheet label "{value}"',
    editCustomLabel: 'Edit custom label {value}',
    customLabelsSelected: 'Selected Custom label {value}',
    customLabelsSuggested: 'Suggested Custom label {value}',
    acceptSuggestion: 'Accept this label suggestion',
    denySuggestion: 'Deny this label suggestion',
    removeBtn: 'Remove this timsheetlabel'
  },
  confirmationDialog: {
    yes: 'Yes',
    cancel: 'Cancel'
  },
  smartDiary: {
    selection: {
      zero: 'No Entries Selected',
      one: '1 Entry Selected',
      more: '{count} Entries Selected'
    },
    total: 'Total',
    emptyMessage: 'No entries for selected day',
    empty: {
      applied: {
        title: 'Nothing Here!',
        rebrandingTitle: 'One last step!',
        subtitle: 'We don’t have anything to display',
        rebrandingSubtitle:
          'Please review your “Not Applied” tab and click “Apply to Timesheet”'
      },
      not_applied: {
        title: 'Nothing Here!',
        rebrandingTitle: 'Nothing for your timesheet here!',
        subtitle: 'We don’t have anything to display',
        rebrandingSubtitle:
          'Please accept entries in MyWork to be applied to your Timesheet.'
      },
      all: {
        title: 'Nothing Here!',
        rebrandingTitle: 'Nothing here!',
        subtitle: 'We don’t have anything to display',
        rebrandingSubtitle:
          'Please accept entries in MyWork to be applied to your Timesheet.'
      }
    },
    headerMsgCollapse:
      ' of date:"{date}" having {duration} total duration collapse',
    headerMsgExpand:
      ' of date:"{date}" having {duration} total duration expand',

    na: 'N/A',
    noCPTClient: 'Client',
    noCPTProgram: 'Program',
    noProject: 'Project: Not Selected',
    noTask: 'Task: Not Selected',
    noCPTTask: 'Task',
    noCPTProject: 'Project',
    noClient: 'Client: Not Selected',
    noProgram: 'Program: Not Selected',
    noCPTSelect: 'Select',
    no: 'No',
    selected: 'Selected',
    notSelected: 'Not Selected',
    warning: {
      commentExceededMaxLimit: 'Comment has more than {maxLimit} characters'
    },
    applyToTimesheet: 'Apply to timesheet',
    applyNToTimesheet: 'Apply {count} to timesheet',
    sychMessages: {
      allSuccess: 'Timesheet successfully updated.',
      partialSuccess: '{successCount} of {totalCount} successfully updated.',
      failureMessage: '{errorCount} of {totalCount} failed to update.',
      fullFailureMessage:
        'Update Failure: We were Unable to update your Timesheet.  Please retry again',
      linkTitle: 'DETAILS'
    },
    errorDialog: {
      close: 'Close',
      syncFailedTitle: 'Apply to Timesheet Failed',
      timesheetReadonly:
        'Unable to "Apply to Timesheet" as this timesheet is already submitted. Please re-open your timesheet and try again OR contact your System Admin.',
      timeEntriesReadonly:
        'Unable to "Apply to Timesheet" as the {errorCount} selected entry(s) are already submitted. Please re-open your time entry(s) and try again OR contact your System Admin.'
    },
    lastSyncTime: 'Last Update:',
    lastSyncNotAvailable: 'N/A',
    commentErrorMessage: '"Comment" cannot be more than {maxLimit} characters',
    actionMessage: {
      new: 'New Entry',
      update: 'Updated Entry',
      remove: 'Will Remove'
    },
    currentTimesheetPeriod: 'Current Period',
    tabs: {
      applied: 'Applied',
      notApplied: 'Not Applied',
      all: 'All'
    },
    loading: 'Loading...',
    markedToRemove: 'Marked to Remove',
    willRemove: 'Will Remove',
    lastAppliedLabel: 'Last Applied to Timesheet',
    neverSynced: 'Never',
    removedFromTimesheet: 'Excluded from ZT and updating Timesheet.',
    submitProgress: {
      heading: 'Applying to your timesheet.',
      subHeading: 'Please wait...',
      done: 'Done!'
    },
    inlineTimer: {
      dialog: {
        title: 'Applying to Timesheet',
        message1: 'Applying to timesheet will stop the timer.',
        message2: 'Would you like to continue?',
        action: {
          continue: 'Continue',
          cancel: 'Cancel'
        }
      }
    }
  },
  labels: {
    client: 'Client',
    project: 'Project',
    task: 'Task',
    billing: 'Billing',
    activity: 'Activity',
    program: 'Program',

    totalDuration: 'Total Duration',
    startTime: 'Start Time',
    endTime: 'End Time'
  },
  embeddedTimesheet: {
    title: 'Timesheet'
  },
  searchableChip: {
    loading: 'Loading…',
    more: {
      optionsText: 'More {results} available. Search to refine results.',
      CLIENT: 'clients',
      PROJECT: 'projects',
      TASK: 'tasks',
      SELECT: 'options',
      ACTIVITY: 'Activities',
      PROGRAM: 'Programs',
      BILLING: 'Billings'
    }
  },
  toast: {
    note: {
      added: 'New Note Added',
      addedTo: {
        unclassified: '"{message}" added to Inbox',
        accepted: '"{message}" added to Accepted',
        private: '"{message}" added to Private'
      },
      updated: 'Note Updated',
      noteUpdated: '"{message}" updated',
      failure: 'Something went wrong! Unable to perform this action.',
      noChange: 'No changes applied',
      autoReload: 'New Recommendations Available',
      classification: {
        single: {
          privated: 'Note marked as Private',
          accepted: 'Note Accepted',
          movedToTrash: 'Note moved to Trash',
          movedToInbox: 'Note moved to Inbox',
          deletedForever: 'Note Deleted Forever'
        },
        multiple: {
          privated: 'Notes marked as Private',
          accepted: 'Notes Accepted',
          movedToTrash: 'Notes moved to Trash',
          movedToInbox: 'Notes moved to Inbox',
          deletedForever: 'Notes Deleted Forever'
        },
        singleMove: {
          unclassified: '"{message}" moved to Inbox',
          private: '"{message}" moved to Private',
          accepted: '"{message}" moved to Accepted',
          trash: '"{message}" moved to Trash',
          deleteforever: '"{message}" Deleted Forever'
        },
        bulkMove: {
          unclassified: '{count} notes moved to Inbox',
          accepted: '{count} notes moved to Accepted',
          private: '{count} notes moved to Private',
          trash: '{count} notes moved to Trash',
          deleteforever: '{count} notes Deleted Forever'
        }
      },
      split: {
        success: 'Note Split Successful',
        successfulSplitTo: {
          common: '"{message}" splitted to {count} notes',
          unclassified:
            '"{message}" splitted to {count} notes and moved to Inbox',
          accepted:
            '"{message}" splitted to {count} notes and moved to Accepted',
          private: '"{message}" splitted to {count} notes and moved to Private'
        },
        failure: 'Note Split Failed'
      },
      excluded: {
        success: '"{message}" excluded from Smart Diary'
      },
      included: {
        success: '"{message}" included in Smart Diary'
      },
      inlineTimer: {
        myWork: {
          success: 'Timer Stopped: '
        },
        success: 'Timer Stopped for ',
        failure: 'Something went wrong! Unable to perform this action.'
      }
    },
    timeEntryAnimation: {
      Unclassified: 'Moving to Inbox',
      Accepted: 'Moving to Accepted',
      Private: 'Moving to Private',
      Trash: 'Moving to Trash',
      DeleteForever: 'Deleting forever'
    }
  },
  errorPage: {
    title: 'ZeroTime™',
    traceIdLabel: 'Trace ID:',
    _503: {
      title: 'Service Unavailable',
      subText: 'Sorry, it’s me, not you.',
      buttonText: 'Refresh'
    },
    _500: {
      title: 'Oops, something went wrong',
      subText: 'If the problem persists, please report an issue.',
      buttonText: 'Go To Home'
    },
    _403: {
      title: 'You are not allowed to enter here',
      subText: 'Access Forbidden',
      buttonText: 'Go To Home'
    },
    _404: {
      title: 'Oops, it looks like you’re lost',
      subText: 'The page you’re looking for was moved, removed or renamed.',
      buttonText: 'Go To Home'
    },
    noAccess: {
      title: 'You are not allowed to enter here',
      subText: 'Access Forbidden',
      buttonText: 'Go To Home'
    }
  },
  session: {
    expiring: 'Session Expiring Soon!',
    expiresIn: 'Your session will expire in',
    seconds: 'seconds',
    continuePrompt: 'Do you want to continue?',
    logout: 'Logout',
    continue: 'Continue',
    reason: {
      expired: 'Your session has expired. Please login to continue.',
      different_user:
        'A different user has signed in. Please login to continue.',
      logout_elsewhere:
        'Your session has been logged out. Please login to continue.'
    }
  },
  searchBox: {
    searchBy: 'Search by "{phrase}"',
    search: 'Search',
    applySearch: 'Apply Search',
    clear: 'Clear',
    error: {
      dateValidation: 'Start Date cannot be greater than End Date',
      invalidDateFormat: 'Invalid Date Format',
      startDateOutOfRange: 'Start Date cannot be beyond 90 days from today',
      endDateOutOfRange: 'End Date cannot be beyond 90 days from today'
    },
    clKeyHint: 'Select a Key',
    searchMsg: 'Search notes by your required fields'
  },
  sort: {
    tooltips: {
      descending: 'Newest to Oldest',
      ascending: 'Oldest to Newest'
    },
    title: 'List Day By'
  },
  search: {
    hasWords: 'Has Words',
    title: 'Search',
    facets: {
      dateRange: 'Dates',
      loading: 'Loading ...',
      noneOption: 'No options available',
      noClient: 'No Client',
      noProgram: 'No Program',
      noProject: 'No Project',
      noActivity: 'No Activity',
      customLabel: 'Key'
    }
  },
  settings: {
    startEndTime: 'Start/End Time',
    smartSuggestion: 'Smart Suggestions',
    autoPopulate: 'Auto Populate',
    addTargetButton: 'Add Targeted Value',
    usersIn: 'Users In',
    enabledDisabled: {
      enabled: 'Enabled',
      disabled: 'Disabled'
    },
    remove: 'Remove the entire row',
    groups: {
      single: {
        DEPARTMENT: 'Department',
        EMPLOYEE_TYPE: 'Employee Type',
        LOCATION: 'Location',
        COST_CENTER: 'Cost Center',
        DIVISION: 'Division',
        SERVICE_CENTER: 'Service Center'
      },
      no: {
        DEPARTMENT: 'No Departments',
        EMPLOYEE_TYPE: 'No Employee Types',
        LOCATION: 'No Locations',
        COST_CENTER: 'No Cost Centers',
        DIVISION: 'No Divisions',
        SERVICE_CENTER: 'No Service Centers'
      },
      moreLabels: {
        DEPARTMENT: 'departments',
        EMPLOYEE_TYPE: 'employee types',
        LOCATION: 'locations',
        COST_CENTER: 'cost centers',
        DIVISION: 'divisions',
        SERVICE_CENTER: 'service centers'
      }
    },
    defaultValue: 'Default Value',
    loading: 'loading ...',
    more: {
      optionsText: 'More {label} available. Search to refine results.'
    },
    save: 'Save',
    startEndSaveSuccessMessage: 'Successfully saved Start/End Settings',
    smartSuggestionSaveSuccessMessage:
      'Successfully saved Smart Suggestion Settings',

    removeDialog: {
      title: 'Removing the Value',
      dialogText1:
        'This action will affect selected users in your corporation.',
      dialogText2: 'Are you sure you want to continue?',
      Remove: 'Remove',
      Cancel: 'Cancel'
    }
  },
  installedCollectors: {
    collectorName: 'Collector Name',
    type: 'Type',
    installedBy: 'Installed By',
    date: 'Date',
    status: 'Status',
    action: 'Action',
    empty: {
      title: 'Nothing Here!',
      subtitle: 'We don’t have anything to display'
    },
    confirmDialog: {
      title: 'Opting out from {collectorName}',
      optout: 'OPT-OUT',
      cancel: 'CANCEL',
      confirmationMessage:
        'You will no longer receive this application’s information on ZeroTime™ after you opt out.',
      confirmMessage: 'Are you sure you want to opt-out?'
    },
    snackBarMessage: {
      optedIn: 'Opted In to',
      optedOut: 'Opted Out from'
    },
    installedOn: 'on'
  },
  collectorType: {
    company: 'Company',
    user: 'User',
    self: 'Self'
  },
  installedBy: {
    admin: 'Admin',
    self: 'Self'
  },
  installationOpted: {
    in: 'Opted In',
    out: 'Opted Out',
    enabled: 'Enabled'
  },
  labelType: {
    CLIENT: 'Client',
    PROJECT: 'Project',
    TASK: 'Task',
    PROGRAM: 'Program',
    ACTIVITY: 'Activity',
    BILLING: 'Billing',
    COMMENT: 'Comment',
    NoLabel: 'No {Label}',
    customLabel: 'Custom Label',
    SELECT: 'Timesheet Field'
  },
  dropDownLabel: {
    collectorStatus: 'Collector Installation',
    TimeRange: 'Time Period',
    groupBy: 'Group By',
    insightsTimeBreakDown: 'Time BreakDown',
    TeamHours: 'Team Hours',
    utilizationChart: 'Utilization Chart'
  },
  myWorkViewSwitcher: {
    timeline: 'Timeline View',
    list: 'List View'
  },
  expandAll: 'Expand All',
  collapseAll: 'Collapse All',
  collapseAllwithDuration: 'all notes having duration {duration} collapse all',
  expandAllwithDuration: 'all notes having duration {duration} expand all',
  expand: 'Expand',
  collapse: 'Collapse',
  autoPilot: {
    autoPopulateEnabled: 'Auto Populate Enabled'
  },
  insights: {
    prev: 'Previous insights period',
    next: 'Next insights period',
    subMenu: {
      notes: 'Notes',
      myInsight: 'My Insight',
      supervisor: 'Supervisor',
      insightLabel: 'Insights'
    },
    viewOptions: {
      custom: 'Custom',
      thisMonth: 'This Month',
      today: 'Today',
      thisWeek: 'This Week',
      lastNinetyDays: 'Last 90 Days'
    },
    timeClassificationChart: {
      ACCEPTED: 'Accepted',
      PRIVATE: 'Private',
      UNCLASSIFIED: 'Inbox',
      noData: 'No Time classification data to display'
    },
    timeBreakdownChart: {
      title: 'Time Breakdown',
      noDataMessage: 'No Time Breakdown Data to Display',
      categories: 'Categories',
      collectors: 'Collectors',
      manualEntries: 'Manual Entries',
      billableUtilization: 'Billable Utilization',
      summary: 'Time Breakdown Chart Summary'
    },
    timeSheetLabels: {
      clients: 'Clients',
      programs: 'Programs',
      projects: 'Projects',
      activity: 'Activity',
      na: 'N/A',
      client: 'client',
      noData: 'No {label} data to display',
      tasks: 'Tasks',
      next: 'Next {pageSize} >',
      prev: '< Prev {pageSize}',
      addOEFChart: 'Timesheet Field',
      ariaLabelMessage: '{name}: {duration}',
      nextButton: 'Show next {chartName} chart data',
      prevButton: 'Show prev {chartName} chart data',
      chartName: '{chartName} chart',
      removeOEFChart: 'Remove {chartName} chart',
      noDataAriaLabel: 'No chart data available'
    },
    timeUtilizationChart: {
      userUtilizationChartHeading: 'My Utilization',
      chartSvgName: 'My Utilization chart',
      supervisorProductivity: 'Team Productivity',
      supervisorUtilization: 'Team Utilization',
      noDataMessage: 'No Utilization Data to Display',
      next: 'Next >',
      prev: '< Prev',
      hideDaysLabel: 'Hide Days with No Data',
      ariaLabelMessage: 'On {date} {name}: {duration}'
    },
    dataScience: {
      accuracy: 'Suggestion Accuracy',
      accuracyNA: 'N/A'
    },
    keywordCloud: {
      title: 'Keyword Cloud',
      noDataMessage: 'No Keyword Cloud Data to Display'
    },
    autoAccept: {
      SYSTEM: 'Auto Acceptance',
      USER: 'Manual Acceptance',
      vs: '-vs-'
    },
    myTeamHoursLegend: {
      minHour: '0h',
      maxHours: '8h',
      overTime: 'Over Time'
    },
    teamTable: {
      nameColumn: 'My Team',
      total: 'Total',
      loading: 'Loading ...',
      noDataMessage: 'No Team Data to Display',
      hours: 'Hours',
      scheduleHours: 'Schedule Hours: {scheduleHours}',
      actualHours: 'Actual Hours: {actualHours}',
      overtimeHours: 'Overtime Hours: {overTimeHours}',
      utilization: 'Utilization',
      billable: 'Billable Utilization',
      billableDurationText: '{billableHours} of {scheduleHours}'
    },
    teamProductivity: {
      hours: {
        'time-entry-billable-duration': 'Billable Hours',
        'unaccounted-hours': 'Unaccounted Hours',
        'time-entry-non-billable-duration': 'Non Billable Hours',
        remaining: 'Remaining Hours'
      },
      chart: {
        scheduledHours: 'Scheduled Hours: {duration}',
        noDataMessage: 'No Team Productivity Data to Display'
      }
    },
    summaryHours: {
      'work-schedule': 'Scheduled',
      'time-entry-revision-group': 'Worked',
      remaining: 'Remaining'
    },
    productivityChart: {
      'unaccounted-hours': 'Unaccounted Hours',
      'work-schedule': 'Schedule',
      'time-entry-billable-duration': 'Billable Hours',
      'time-entry-non-billable-duration': 'NonBillable Hours',
      noDataMessage: 'No Productivity Data to Display'
    }
  }
};
export default flattenMessages(messages);
